var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"counter__containter"},[(_vm.days)?_c('span',{staticClass:"mr-1"},[_vm._v(_vm._s(_vm.days)+"d")]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.timeSentence))])])}
var staticRenderFns = []

export { render, staticRenderFns }